export default __webpack_public_path__ + "static/media/delete-icon.4860bb00.svg";